<template>
    <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark class="primary">
                <v-btn icon @click.native="dialog = false" dark>
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Settings</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark flat @click.native="dialog = false">Save</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-list three-line subheader>
                <v-subheader>User Controls</v-subheader>
                <v-list-tile avatar>
                    <v-list-tile-content>
                        <v-list-tile-title>Content filtering</v-list-tile-title>
                        <v-list-tile-sub-title>Set the content filtering level to restrict appts that can be downloaded <div>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Fugiat at aut, minus odit quae doloribus? Consequuntur, dolor? Beatae nesciunt ipsam enim distinctio ratione aut! Ipsa vero reprehenderit recusandae sed dicta.</div></v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    module: Object,
    step: Object,
    item: Object
  }
}
</script>
